.root {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: var(--sunk);
  border-radius: 9px;
  padding: 3px;
}

.item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--ink-3);
  cursor: pointer;
  font: inherit;
  font-size: 12.5px;
  font-weight: 550;
  white-space: nowrap;
}

.active {
  background: var(--panel);
  color: var(--ink);
}

.count {
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 10.5px;
  color: var(--ink-3);
}
